import { Grid, InputLabel } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import SellProduct from '../datatables/SellProduct';
import { searchAction } from '../../redux/reducers/Search';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import { useDispatch } from 'react-redux';

const ProductList = () => {

  const dispatch = useDispatch();

  return (
    <>
        <Grid item xs={12}>
          <Grid container sx={{ justifyContent: 'end' }}>
            <Grid item xs={12} sm={4} md={3}>
              <PrimaryLightInput
                placeholder='Buscar producto'
                type='text'
                sx={{ width: '100%', mt:2  }}
                onChange={ e => dispatch(searchAction(e.target.value)) }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={ 12 } sx={{ mt:1 }}>
            <SellProduct />
        </Grid>
      
    </>
  )
}

export default ProductList